import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Cookie } from 'ng2-cookies';
import { JwtService } from '../../jwt/jwt.service';

/**
 * 라우터로 페이지 이동 시 accessToken 체크
 */
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private jwtService: JwtService) {}

  canActivate() {

    if (this.router.url === '/sign/make' || this.router.url === '/sign/list' || this.router.url === '/poster/list') {
      $('#modalClose').click();
    }
    if (this.jwtService.checkAccessToken()) {

      if (this.jwtService.checkTokenExpiration()) {
      } else {
        return true;
      }

    }
    alert('로그인이 필요합니다.');

    return false;
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/common/guard/auth.guard.ts